import ApplicationController from "./application_controller";
import { FetchRequest } from '@rails/request.js'
import { get, post, put, patch, destroy } from '@rails/request.js'

import "~/stylesheets/board_containers.css";

/* This is the custom StimulusReflex controller for the Posts Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {

  connect() {
    console.log("did connect Admin controller");
  }

  async destroyUsers(event) {
    event.preventDefault();
    event.stopPropagation();

    let selectedUserIds = this.getSelectedUserIds();
    let confirmTarget = event.target.closest("[data-confirmmsg]");
    let countItems = selectedUserIds.length;
    if (countItems == undefined || countItems == 0) {
      alert("No items selected!");
      return false;
    }
    let message = confirmTarget.dataset.confirmmsg || "Are you sure you would like to delete " + countItems + " items?";
    const ok = confirm(message);
    if (ok) {
      const response = await destroy(confirmTarget.href, { body: JSON.stringify({ user_ids: selectedUserIds }) })
      if (response.ok) {
        const body = await response.json
        alert(body.message);
        location.reload();
      }
    }
  }

  getSelectedUsers() {
    return Array.from(
      this.element.querySelectorAll("table tr:has(input[type=checkbox]:checked)"),
    );
  }
  getSelectedUserIds() {
    let userRows = this.getSelectedUsers();
    console.log(userRows[0].dataset.userId)
    return userRows.map(row => row.dataset.userId);
  }
}
